import { render, staticRenderFns } from "./BdoCheckbox.vue?vue&type=template&id=5f219234&scoped=true"
import script from "./BdoCheckbox.vue?vue&type=script&lang=js"
export * from "./BdoCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BdoCheckbox.vue?vue&type=style&index=0&id=5f219234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f219234",
  null
  
)

export default component.exports